import { render, staticRenderFns } from "./SystemKeys.vue?vue&type=template&id=5c0a867a&"
import script from "./SystemKeys.vue?vue&type=script&lang=js&"
export * from "./SystemKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports